import axios from "axios";
import { isSignedInLocalCookieName } from "peggirkit";
export var serpotrackAxios = axios.create({
    baseURL: process.env.SERPOTRACK_API_BASE_URL,
    withCredentials: true,
});
serpotrackAxios.interceptors.response.use(function (response) { return response; }, function (error) {
    var _a;
    if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
        localStorage.removeItem(isSignedInLocalCookieName);
        location.reload();
    }
    return Promise.reject(error);
});
export var getCurrentUser = function () { return (serpotrackAxios
    .get("/user")
    .then(function (response) { return response.data; })); };
export var signIn = function (emailAddress, password) { return (serpotrackAxios
    .post('/auth/sign-in', {
    username: emailAddress,
    password: password
})
    .then(function (response) { return ({
    statusCode: response.status,
    message: response.data
}); })); };
export var finishSignInWithTotpMfa = function (emailAddress, password, totp, mfaRequestToken) { return (serpotrackAxios
    .post('/auth/sign-in/totp', {
    username: emailAddress,
    password: password,
    totp: totp,
    mfaRequestToken: mfaRequestToken,
})
    .then(function (response) { return response.data; })); };
export var signOut = function () { return (serpotrackAxios
    .post('/auth/sign-out')
    .then(function (response) { return response.data; })); };
export var registerUser = function (username, password) { return (serpotrackAxios
    .post('/auth/register', {
    username: username,
    password: password
})
    .then(function (response) { return response.data; })); };
export var requestPasswordReset = function (emailAddress) { return (serpotrackAxios
    .post("/auth/reset", { username: emailAddress })
    .then(function (response) { return response.data; })); };
export var confirmPasswordReset = function (emailAddress, token, password) { return (serpotrackAxios
    .post("/auth/reset/confirm", {
    username: emailAddress,
    token: token,
    password: password
})
    .then(function (response) { return response.data; })); };
export var updatePassword = function (currentPassword, newPassword) { return (serpotrackAxios
    .put("/user/password", {
    currentPassword: currentPassword,
    newPassword: newPassword
})
    .then(function (response) { return response.data; })); };
export var confirmAccount = function (token) { return (serpotrackAxios
    .put("/user/confirm", {
    token: token
})
    .then(function (response) { return response.data; })); };
export var listInvoices = function () { return (serpotrackAxios
    .get("/subscriptions/invoices")
    .then(function (response) { return response.data; })); };
export var getFirstPaymentCheckoutUrl = function (keywordLimit, keywordUpdateHourlyIntervalLimit, keywordMaxPositionLimit) { return (serpotrackAxios
    .post("/subscriptions/", {
    keywordLimit: keywordLimit,
    keywordUpdateHourlyIntervalLimit: keywordUpdateHourlyIntervalLimit,
    keywordMaxPositionLimit: keywordMaxPositionLimit
})
    .then(function (response) { return response.data; })); };
export var cancelActiveSubscription = function () { return (serpotrackAxios
    .put("/subscriptions/cancel")
    .then(function (response) { return response.data; })); };
export var startTrial = function () { return (serpotrackAxios
    .post("/subscriptions/trial")
    .then(function (response) { return response.data; })); };
export var createProject = function (name, url, device, geographicalLocation, homeLocation) { return (serpotrackAxios
    .post("/projects", {
    name: name,
    url: url,
    device: device,
    geographicalLocation: geographicalLocation,
    homeLocation: homeLocation
})
    .then(function (response) { return response.data; })); };
export var updateProject = function (projectId, newName) { return (serpotrackAxios
    .put("/projects/".concat(projectId), {
    name: newName,
})
    .then(function (response) { return response.data; })); };
export var getProject = function (projectId) { return (serpotrackAxios
    .get("/projects/".concat(projectId))
    .then(function (response) { return response.data; })
    .catch(function (error) { return Promise.reject(error); })); };
export var deleteProject = function (projectId) { return (serpotrackAxios
    .delete("/projects/".concat(projectId))
    .then(function (response) { return response.data; })); };
export var getUsageData = function () { return (serpotrackAxios
    .get("/user/usage")
    .then(function (response) { return response.data; })); };
export var addKeywords = function (projectId, keywords) { return (serpotrackAxios
    .post("/projects/".concat(projectId, "/keywords"), keywords)
    .then(function (response) { return response.data; })); };
export var deleteKeywords = function (projectId, keywordIds) { return (serpotrackAxios
    .delete("/projects/".concat(projectId, "/keywords"), {
    data: keywordIds
})
    .then(function (response) { return response.data; })); };
export var resendConfirmEmail = function () { return (serpotrackAxios
    .put("/user/confirm/resend")
    .then(function (response) { return response.data; })); };
export var requestEnableMfaTotp = function () { return (serpotrackAxios
    .post("/user/mfa/totp/enable")
    .then(function (response) { return response.data; })); };
export var confirmEnableMfaTotp = function (totp) { return (serpotrackAxios
    .post("/user/mfa/totp/enable/confirm", {
    totp: totp
})
    .then(function (response) { return response.data; })); };
export var removeMfaTotp = function () { return (serpotrackAxios
    .delete("/user/mfa/totp")
    .then(function (response) { return response.data; })); };
export var regenerateBackupCodes = function () { return (serpotrackAxios
    .put("/user/mfa/totp/backup-codes")
    .then(function (response) { return response.data; })); };
